<template>
	<el-popover
		placement="bottom"
		popper-class="ModuleAccountInfoPopover"
		width="auto"
		trigger="hover"
	>
		<template #reference>
			<slot></slot>
		</template>
		<div class="ModuleAccountInfoPopoverBody">
			<div class="ModuleAccountInfoPopoverBodyValue">
				<!-- <el-icon><UserFilled /></el-icon> -->
				<div class="ModuleAccountInfoPopoverBodyValueTitle">账号名称：</div>
				<div class="ModuleAccountInfoPopoverBodyValueBody">{{AdminName}}</div>
			</div>
			<div class="ModuleAccountInfoPopoverBodyValue">
				<div class="ModuleAccountInfoPopoverBodyValueTitle">账号角色：</div>
				<div class="ModuleAccountInfoPopoverBodyValueBody">
					<el-tag type="danger" effect="plain" v-if="RoleJsonData.length <= 0">未配置角色</el-tag>
					<el-tag type="info" v-else v-for="RoleData in RoleJsonData">{{RoleData.Title}}</el-tag>
				</div>
			</div>
			<div class="ModuleAccountInfoPopoverBodyLine"></div>
			<div class="ModuleAccountInfoPopoverBodyUpdate">
				<!-- <el-icon><Key /></el-icon> -->
				<span>登录密码</span>
				<div class="ModuleAccountInfoPopoverBodyUpdateBtn">
					<el-button @click="Admin_Update_Password_Show()">
						<el-icon><Edit /></el-icon>
						<span>修改</span>
					</el-button>
				</div>
			</div>
			<div class="ModuleAccountInfoPopoverBodyUpdate">
				<!-- <el-icon><Key /></el-icon> -->
				<span>操作密码</span>
				<div class="ModuleAccountInfoPopoverBodyUpdateBtn">
					<el-button @click="Admin_Update_KeyCode_Show()">
						<el-icon><Edit /></el-icon>
						<span>修改</span>
					</el-button>
				</div>
			</div>
			<div class="ModuleAccountInfoPopoverBodyLine"></div>
			<div class="ModuleAccountInfoPopoverBodyBtn">
				<el-button type="danger" @click="Logout()">
					<el-icon><SwitchButton /></el-icon>
					<span>退出系统</span>
				</el-button>
			</div>
		</div>
	</el-popover>
</template>

<style lang="scss" scoped>
	@import "./index.scss";
</style>
<script>
  import index from "./index-Js";
  export default index;
</script>

